<template>
  <v-container
    fluid
    class="pa-0 container_background fill-height"
    :style="getBackgroundStyle()">

    <!-- <v-row>
      <v-col class="pa-6">
        <v-btn
          @click="signUpDialog = true"
          depressed
          color="#00b0b9"
          dark>
          SIGN UP
        </v-btn>
      </v-col>
    </v-row> -->

    <v-row>
      <v-col>
        <v-row
          align="center"
          justify="center">

          <v-img
            :src="'https://etap.co.nz/sites/' + Dbasename + '/logo.png'"
            :alt="Dbasename + ' Logo'"
            width="75"
            contain
            max-height="100"/>
        </v-row>
        <v-row
          v-if="Dbasename != 'Patumahoe'"
          align="center"
          justify="center">
          <div class="font-weight-bold subheading">{{ schoolName }}</div>
        </v-row>
        <v-divider
          :class="{ 'mt-2': Dbasename === 'Patumahoe' }"
          class="ml-3 mr-3"/>
        <div v-if="Dbasename === 'Matua'">
          <v-row
            align="center"
            justify="center"
          >
            <v-img
              :src="'https://etap.co.nz/sites/' + Dbasename + '/Sponsor_Logo_Update.png'"
              :alt="Dbasename + ' Logo'"
              :width="$vuetify.breakpoint.smAndDown ? '50' : '75'"
              :height="$vuetify.breakpoint.smAndDown ? 'auto' : 'auto'"
              contain
              class="responsive-img"
            />
          </v-row>
        </div>
        <v-divider class="ml-3 mr-3"/>
        <v-row
          align="center"
          justify="center">
          <v-col
            cols="4"
            sm="3"
            md="2"
            v-for="pupil in pupilsArr"
            :key="pupil.id">
            <v-container>
              <v-col
                class="align"
                style="cursor: pointer;"
                @click="changePupil(pupil.id)">
                <v-row
                  align="center"
                  justify="center">
                  <v-avatar size="60">
                    <v-img
                      :class="{ 'selectedBorder': pupilId == pupil.id }"
                      @error="pupil.photo = './img/photo.png'"
                      :src="pupil.photo"/>
                  </v-avatar>
                </v-row>
                <v-row
                  align="center"
                  justify="center">
                  <div
                    class="text-center"
                    :class="{ 'darkorange--text': pupilId == pupil.id }">{{ pupil.PerferredName }}</div>
                </v-row>
              </v-col>
            </v-container>
          </v-col>
        </v-row>
        <v-alert
          v-if="medicineWarnings.length"
          type="warning"
          dense
          text
          dismissible
          class="mx-3 mt-3"
          @input="dismissMedicineWarning">
          <div class="font-weight-bold">Medicine/information expiring soon</div>
          <div
            v-for="item in medicineWarnings"
            :key="item.key"
            class="body-2">
            {{ item.title }} - expires <strong>{{ item.expiryLabel }}</strong>
          </div>
          <div class="caption mt-1">Please contact the school to provide an updated item.</div>
        </v-alert>
        <v-dialog
          v-model="dialog"
          eager
          persistent
          no-click-animation
          fullscreen
          hide-overlay
          style="-webkit-overflow-scrolling: touch;"
          transition="slide-x-reverse-transition">
          <v-card height='100%'>
            <v-app-bar
              v-if="showAppBar"
              fixed
              style="border-top-left-radius: 0; border-top-right-radius: 0;"
              :style="'background-color: ' + appColour"
              :dark="darkToolbar"
              v-touch="{ right: () => closeDialog() }">
              <v-btn
                icon
                @click.native="closeDialog()">
                <v-icon>arrow_back</v-icon>
              </v-btn>
              <v-toolbar-title class="ml-0">{{ currentDialogTitle }}</v-toolbar-title>
              <v-spacer/>
            </v-app-bar>
            <v-content>
              <router-view/>
            </v-content>
          </v-card>
        </v-dialog>

        <v-footer
          height="auto"
          class="overflow-hidden"
          color="rgba(0, 0, 0, 0)">
          <v-row
            class="menu_layout color"
            :style="'border-top: 2px solid ' + appColour"

            align="start"
            justify="start"
          >
            <v-col cols="12">
              <v-alert
                v-if="showAppAlert && !(Object.keys(menuConfigResp).length > 0)"
                :value="true"
                type="info"
                class="white--text"
                transition="scale-transition">
                The @school App has not been set up by your school yet. Please contact your school for more information about the new @school App. If you're experiencing loading issues, you can try pressing the
                <v-btn @click="refreshPage">Refresh</v-btn>
                button to reload the app.
              </v-alert>
            </v-col>
            <v-col
              v-if="Dbasename === 'Normandale' || Dbasename === 'TeMata'"
              cols="4"
              sm="3"
              md="2"
              class="text-center">
              <v-container
                style="
      height: 100px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    "
              >
                <a
                  href="https://app.seesaw.me/#/login?role=parent"
                  target="_blank"
                  style="text-decoration: none;"
                  rel="noopener"
                >
                  <v-avatar
                    size="40"
                    class="mb-1">
                    <img
                      src="https://edit2.etap.co.nz/atschool/images/seesaw.png"
                      alt="Seesaw"
                    >
                  </v-avatar>
                  <div
                    class="black--text"
                    style="font-size: 16px;">Seesaw</div>
                </a>
              </v-container>
            </v-col>
            <v-col
              v-if="Dbasename === 'TeMata' || Dbasename === 'OurLadyRosary'"
              cols="4"
              sm="3"
              md="2"
              class="text-center">
              <v-container
                style="
      height: 100px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    "
              >
                <a
                  href="https://shop.kindo.co.nz/app/login"
                  target="_blank"
                  style="text-decoration: none;"
                  rel="noopener"
                >
                  <v-avatar
                    size="40"
                    class="mb-1">
                    <img
                      src="https://edit2.etap.co.nz/atschool/images/kindo_icon.png"
                      alt="Kindo"
                    >
                  </v-avatar>
                  <div
                    class="black--text"
                    style="font-size: 16px;">Kindo</div>
                </a>
              </v-container>
            </v-col>
            <v-col
              v-if="Dbasename === 'OurLadyRosary'"
              cols="4"
              sm="3"
              md="2"
              class="text-center">
              <v-container
                style="
      height: 100px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    "
              >
                <a
                  href="https://olr.schooldocs.co.nz/Logon.aspx?ReturnUrl=%2f"
                  target="_blank"
                  style="text-decoration: none;"
                  rel="noopener"
                >
                  <v-avatar
                    size="40"
                    tile
                    class="mb-1">
                    <img
                      src="https://edit2.etap.co.nz/atschool/images/school_docs.png"
                      alt="SchoolDocs"
                    >
                  </v-avatar>
                  <div
                    class="black--text"
                    style="font-size: 16px;">School Docs</div>
                </a>
              </v-container>
            </v-col>
            <v-col
              cols="4"
              sm="3"
              md="2"
              v-for="(settings, index) in menuConfig"
              :key="index">
              <v-container
                style="
                min-height: 100px;
                padding: 5px;
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                "
              >
                <router-link
                  tag="span"
                  :to="settings.route"
                  @click.native="setDialogTitle(settings.menuItem)"
                  v-if="typeof settings.route !== 'undefined'">
                  <menu-button
                    :menu-item="settings.menuItem"
                    :settings="settings"
                    :custom-menu-names="customMenuNames"/>
                </router-link>
                <a
                  :href="getLinkURL(settings.link)"
                  target="_blank"
                  style="text-decoration: none;"
                  rel="noopener"
                  @click="addLog(settings.link)"
                  v-else>
                  <menu-button
                    :menu-item="settings.menuItem"
                    :settings="settings"
                    :custom-menu-names="customMenuNames"
                  />
                </a>
              </v-container>
            </v-col>
          </v-row>
        </v-footer>
      </v-col>
    </v-row>

    <sign-up
      :sign-up-dialog="signUpDialog"
      @closeSignUp="closeSignUp"/>
  </v-container>
</template>

<script>
import MenuButton from '../components/MenuButton'
import SignUp from '../components/SignUp'

import { mapState } from 'vuex'

export default {
  name: 'Home',

  components: {
    MenuButton,
    SignUp
  },

  data: () => ({
    // dialogTitle: '',
    reminderAlert: true,
    savedY: 0,
    dialogComponent: '',
    schoolWebsite: '',
    learningSpaceLink: '',
    learnerProfileLink: '',
    graphLink: '',
    attendanceLink: '',
    dataTableLink: '',
    studentTimeTableLink: '',
    learningPathwayLink: '',
    expiryText: '',
    menuItems: {
      'School Notices': {
        icon: 'fa-newspaper',
        colour: '#00B0B9',
        route: '/notices'
      },
      'Notices': {
        icon: 'fa-newspaper',
        colour: '#00B0B9',
        route: '/notices'
      },
      'Favourites': {
        icon: 'fa-star',
        colour: 'yellow',
        route: '/favourites'
      },
      'Absence': {
        icon: 'fa-clock',
        colour: 'red',
        route: '/absence'
      },
      'Assessments': {
        icon: 'fa-list-alt',
        colour: 'purple',
        route: '/assessment'
      },
      'Tests': {
        icon: 'fa-list-alt',
        colour: 'purple',
        route: '/assessment'
      },
      'Spotlight': {
        icon: 'highlight',
        colour: 'purple',
        route: '/spotlight'
      },
      'Spotlight Test': {
        icon: 'highlight',
        colour: 'black',
        route: '/spotlighttest'
      },
      'Learning': {
        icon: 'highlight',
        colour: 'purple',
        route: '/spotlight'
      },
      'Calendar': {
        icon: 'fa-calendar-alt',
        colour: 'indigo',
        route: '/calendar'
      },
      'Teacher Messages': {
        icon: 'fa-comment-alt',
        colour: 'green',
        route: '/messages'
      },
      'Messages': {
        icon: 'fa-comment-alt',
        colour: 'green',
        route: '/messages'
      },
      'School Contact': {
        icon: 'fa-phone',
        colour: 'green',
        route: '/contact'
      },
      'Contacts': {
        icon: 'fa-phone',
        colour: 'green',
        route: '/contact'
      },
      'Kindo': {
        icon: 'fa-credit-card',
        colour: 'blue',
        link: 'https://shop.tgcl.co.nz'
      },
      'Documents': {
        icon: 'fa-archive',
        colour: 'black',
        route: '/documents'
      },
      'Reports': {
        icon: 'fa-file-alt',
        colour: 'pink',
        route: '/reports'
      },
      'Settings': {
        icon: 'fa-cogs',
        colour: 'grey',
        route: '/settings'
      },
      'Settings Two': {
        icon: 'fa-cogs',
        colour: 'blue',
        route: '/settingstwo'
      },
      'School Website': {
        icon: 'fa-globe',
        colour: 'blue',
        link: 'schoolwebsite'
      },
      'My Child': {
        icon: 'fa-child',
        colour: 'indigo',
        route: '/mychild'
      },
      'Blog': {
        icon: 'fa-book-open',
        colour: 'teal',
        route: '/blog'
      },
      'Accounts': {
        icon: 'fa-money-check-alt',
        colour: 'black',
        route: '/accounts'
      },
      'Learning Portfolio': {
        icon: 'fa-sticky-note',
        colour: 'red',
        route: '/portfolio'
      },
      'Newsletters': {
        icon: 'fa-newspaper',
        colour: 'brown',
        route: '/newsletters'
      },
      'Learning Space': {
        icon: 'fa-user-edit',
        colour: 'purple',
        link: 'childspacelink'
      },
      'Student Timetable': {
        icon: 'fa-calendar-check',
        colour: 'purple',
        link: 'studentcalendarlink'
      },

      'Sickbay': {
        icon: 'fa-first-aid',
        colour: 'red',
        route: '/sickbay'
      },
      'Permission Slips': {
        icon: 'fa-sticky-note',
        colour: 'pink lighten-2',
        route: '/permissionslips'
      },
      'Guidance': {
        icon: 'fa-user',
        colour: 'cyan',
        route: '/guidance'
      },

      'Learner Profile': { // only for Parklands
        icon: 'fa-id-card',
        colour: 'black',
        link: 'learnerprofilelink'
      },

      'Spotlight Upload': {
        icon: 'fa-upload',
        colour: 'green',
        route: '/spotlightmyupload'
      },
      'Attendance Reports': {
        icon: 'fa-chart-pie',
        colour: 'pink',
        link: 'attendanceLink'
      },
      'Live Levels': {
        icon: 'fa-thermometer-three-quarters',
        colour: 'blue',
        link: 'graphLink'
      },
      'Cumulative Data Table': {
        icon: 'fa-table',
        colour: 'blue',
        link: 'dataTableLink'
      },
      'Interview': {
        icon: 'book_online',
        colour: '#00b0b9',
        route: '/booking'
      },
      'Chat': {
        icon: 'fa-solid fa-comment-dots',
        colour: '#00b0b9',
        route: '/chat'
      },
      'Link Kids': {
        icon: 'fa-regular fa-users',
        colour: '#00b0b9',
        route: '/kids'
      },
      'Learning Pathway': {
        icon: 'fa-user-edit',
        colour: 'purple',
        link: 'learnerpathwaylink'
      },
      'FODS': {
        icon: 'fa-folder-open',
        colour: 'red',
        route: '/customDocuments'
      },
      'Sports Messages': {
        icon: 'fa-trophy',
        colour: '#00B0B9',
        route: '/sportsMessages',
        background: '#B39DDB'
      }
    },
    menuConfigResp: [],
    showAppAlert: false,
    timer: null,
    lastUserExpiry: '',
    customMenuNames: {},
    signUpDialog: false,
    menuOrder: {},
    medicineWarnings: []
  }),
  computed: {
    ...mapState(['Dbasename', 'parentName', 'schoolName', 'schoolId', 'dialog', 'appColour', 'pupilId', 'userId', 'pupilsArr', 'currentDialogTitle', 'darkToolbar']),
    spotlightURL: function () {
      return 'https://www.atschool.co.nz/SPOTLIGHT/index.php?mod=dashboard&func=show&pid=' + btoa(btoa(this.pupilId)) + '&Dbasename=' + btoa(btoa(this.Dbasename)) + '&user_restriction=true'
    },
    menuConfig: function () {
      if (this.menuOrder && this.menuOrder.length > 0 && this.menuOrder.some(item => item.trim() !== '')) {
        const menuArray = Object.values(this.$store.state.menuConfig)

        let storeMenuWithKey = []
        let bigNum = -10000000
        for (let x in this.menuOrder) {
          storeMenuWithKey[this.menuOrder[x]] = bigNum
          bigNum++
        }

        const sortedMenu = menuArray.sort((a, b) => {
          const aOrder = storeMenuWithKey[a.menuItem] !== undefined ? storeMenuWithKey[a.menuItem] : a.order
          const bOrder = storeMenuWithKey[b.menuItem] !== undefined ? storeMenuWithKey[b.menuItem] : b.order

          return aOrder - bOrder
        })

        return sortedMenu
      } else {
        const menuArray = Object.values(this.$store.state.menuConfig)
        const sortedMenu = menuArray.sort((a, b) => a.order - b.order)
        return sortedMenu
      }
    },
    showAppBar: function () {
      return this.$route.path !== '/pin'
    }
  },
  methods: {
    getMedicineDismissKey: function () {
      return `medicineDismissed_${this.Dbasename}_${this.pupilId}`
    },

    getDismissedMedicine: function () {
      try {
        return JSON.parse(localStorage.getItem(this.getMedicineDismissKey())) || []
      } catch (e) {
        return []
      }
    },

    loadMedicineWarnings: async function () {
      try {
        const resp = await this.$http.get(`medicineNotification/${this.Dbasename}/${this.userId}/${this.pupilId}`)
        const dismissed = this.getDismissedMedicine()
        this.medicineWarnings = (resp.data.items || []).filter(item => !dismissed.includes(item.key))
      } catch (error) {
        console.log(error)
      }
    },

    dismissMedicineWarning: function () {
      const dismissed = this.getDismissedMedicine()
      const keys = this.medicineWarnings.map(item => item.key)
      try {
        localStorage.setItem(this.getMedicineDismissKey(), JSON.stringify([...new Set([...dismissed, ...keys])]))
      } catch (e) {}
      this.medicineWarnings = []
    },
    closeSignUp: function () {
      this.signUpDialog = false
    },
    async refreshPage () {
      await window.location.reload()
    },
    hideReminder: function () {
      this.$store.commit('reminder_alert', false)
    },
    changePupil: async function (newPupilId) {
      this.$store.commit('changePupil', newPupilId)
      location.reload()
      // await this.$http.get(`pupils/${this.Dbasename}/${this.userId}/changeDbasename`)
      await this.$store.dispatch('checkUnreadCounts')
      await this.$store.dispatch('updateATSchoolLog')

      if (this.menuConfig.find((element) => element.menuItem === 'Learning Space') !== undefined) {
        try {
          const resp = await this.$http.get(`pupilsV2/${this.Dbasename}/${this.userId}/${this.pupilId}/learningSpaceLinkV2`)
          const website = resp.data.url
          this.learningSpaceLink = website
        } catch (error) {
          console.log(error)
        }
      }

      if (this.menuConfig.find((element) => element.menuItem === 'Learning Pathway') !== undefined) {
        try {
          const resp = await this.$http.get(`pupils/${this.pupilId}/learningPathwayLink`)
          this.learningPathwayLink = resp.data.url
        } catch (error) {
          console.log(error)
        }
      }

      if (this.menuConfig.find((element) => element.menuItem === 'Student Timetable') !== undefined) {
        try {
          const resp = await this.$http.get(`pupilsV2/${this.Dbasename}/${this.userId}/${this.pupilId}/spotlightCalendarLinkV2`)
          const spotlightChildCalendar = resp.data.url
          this.studentTimetablelink = spotlightChildCalendar
        } catch (error) {
          console.log(error)
        }
      }

      if (this.menuConfig.find((element) => element.menuItem === 'Learner Profile') !== undefined) {
        try {
          const resp = await this.$http.get(`pupils/${this.pupilId}/learnerProfileLink`)
          const website = resp.data.url
          this.learnerProfileLink = website
        } catch (error) {
          console.log(error)
        }
      }

      if (this.menuConfig.find((element) => { return element.menuItem === 'Live Levels' }) !== undefined) {
        try {
          const resp = await this.$http.get('pupilsV2/' + this.Dbasename + '/' + this.pupilId + '/assessmentsGraphV2')

          this.graphLink = resp.data.url
        } catch (error) {
          console.log(error)
        }
      }

      if (this.menuConfig.find((element) => { return element.menuItem === 'Cumulative Data Table' }) !== undefined) {
        try {
          const resp = await this.$http.get('pupilsV2/' + this.Dbasename + '/' + this.pupilId + '/cumulativeDataTableV2')

          this.dataTableLink = resp.data.url
        } catch (error) {
          console.log(error)
        }
      }
    },

    setDialogTitle: function (componentName) {
      this.savedY = scrollY
      this.dialogComponent = componentName
      if (this.Dbasename === 'PBS' && componentName === 'Reports') {
        this.$store.commit('set_dialog_title', 'Learning Summary')
      } else {
        this.$store.commit('set_dialog_title', componentName)
      }
      this.$store.commit('loading', true)
    },

    getLinkURL: function (param) {
      if (param === 'spotlight') {
        return this.spotlightURL
      } else if (param === 'schoolwebsite') {
        return this.schoolWebsite
      } else if (param === 'childspacelink') {
        return this.learningSpaceLink
      } else if (param === 'studentcalendarlink') {
        return this.studentTimetablelink
      } else if (param === 'learnerprofilelink') {
        return this.learnerProfileLink
      } else if (param === 'learnerpathwaylink') {
        return this.learningPathwayLink
      } else if (param === 'graphLink') {
        return this.graphLink
      } else if (param === 'attendanceLink') {
        return this.attendanceLink
      } else if (param === 'dataTableLink') {
        return this.dataTableLink
      } else {
        return param
      }
    },

    addLog: function (urlLink) {
      if (urlLink === 'childspacelink') {
        this.$http.post(`pupils/${this.pupilId}/logChildSpaceLink`)
          .then(resp => {
            // Handle response if needed
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    closeDialog: function () {
      this.$store.commit('toggle_dialog', false)
      this.$store.commit('loading', false)
      this.$router.replace('/home')
      this.$vuetify.goTo(this.savedY, {
        duration: 100
      })
      this.savedY = 0
    },

    getBackgroundStyle: function () {
      if (this.Dbasename !== 'SsPeterPaul') {
        return `background-image: linear-gradient(rgba(255,255,255,.9), rgba(255,255,255,.9)), url(https://www.atschool.co.nz/sites/${this.Dbasename}/logo.png)`
      } else {
        return ''
      }
    },

    getUserExpiry: async function () {
      try {
        const resp = await this.$http.get('userExpiryDateV2/' + this.$store.state.Dbasename)
        this.expiryText = resp.data
        if (resp.data !== '') {
          this.$store.commit('showExpiry', resp.data)
        }
      } catch (error) {
        console.log(error)
      }

      return this.expiryText
    }
  },
  created: async function () {
    this.$store.dispatch('logEngagement', 'app_open')
    this.loadMedicineWarnings()

    const withPinStatus = this.$store.state.withPin
    if (withPinStatus != null) {
      await this.$store.dispatch('fetchPin', this.userId)
    }

    try {
      const resp = await this.$http.get('userExpiryDateV2/' + this.$store.state.Dbasename)
      if (resp.data !== 'undefined' || resp.data !== '') {
        localStorage.setItem('expiryLastLog', resp.data)
      }
    } catch (error) {
      console.log(error)
    }

    this.$store.commit('clear_menu_config')

    try {
      const resp = await this.$http.get('configV2/' + this.$store.state.Dbasename + '/' + 'atschoolPWAMenuLinks')
      if (resp.data.configValue !== '') {
        resp.data.configValue.forEach(configString => {
          let configArr = configString.split(';')
          if (configArr.length === 4) {
            this.$store.commit('add_menu_config_item', {
              name: configArr[0],
              menuItemObj: {
                icon: configArr[1],
                colour: configArr[2],
                link: configArr[3]
              },
              order: -1
            })
          }
        })
      }
    } catch (error) {
      console.log(error)
    }

    try {
      const resp = await this.$http.get('customMenuLinks/' + this.$store.state.Dbasename + '/' + this.$store.state.pupilId + '/' + this.$store.state.userId)
      if (resp.data.configValue !== '') {
        resp.data.configValue.forEach(configString => {
          let configArr = configString.split(';')
          if (configArr.length === 4) {
            this.$store.commit('add_menu_config_item', {
              name: configArr[0],
              menuItemObj: {
                icon: configArr[1],
                colour: configArr[2],
                link: configArr[3]
              },
              order: -1
            })
          }
        })
      }
    } catch (error) {
      console.log(error)
    }

    try {
      const resp = await this.$http.get('customMenuNamesV2/' + this.Dbasename)
      if (resp.data.length !== 0) {
        this.customMenuNames = resp.data
      }
    } catch (error) {
      console.log(error)
    }

    if (this.Dbasename === 'Parkland') {
      this.$store.commit('add_menu_config_item', {
        name: 'Learner Profile',
        menuItemObj: this.menuItems['Learner Profile'],
        order: -1
      })
    }

    try {
      const resp = await this.$http.get(`attendanceChart/${this.$store.state.Dbasename}/${this.$store.state.pupilId}`)

      if (resp.data) {
        this.$store.commit('add_menu_config_item', {
          name: 'Attendance Reports',
          menuItemObj: this.menuItems['Attendance Reports'],
          order: -1
        })
      }
    } catch (error) {
      console.log(error)
    }

    try {
      const resp = await this.$http.get(`liveAndCumulative/${this.$store.state.Dbasename}/${this.$store.state.pupilId}`)

      const showLive = resp.data && typeof resp.data.live !== 'undefined' ? resp.data.live : true
      const showCumulative = resp.data && typeof resp.data.cumulative !== 'undefined' ? resp.data.cumulative : true

      if (showLive) {
        this.$store.commit('add_menu_config_item', {
          name: 'Live Levels',
          menuItemObj: this.menuItems['Live Levels'],
          order: -1
        })
      }

      if (showCumulative) {
        this.$store.commit('add_menu_config_item', {
          name: 'Cumulative Data Table',
          menuItemObj: this.menuItems['Cumulative Data Table'],
          order: -1
        })
      }
    } catch (error) {
      console.log('Error fetching menu configuration:', error)

      // this.$store.commit('add_menu_config_item', {
      //   name: 'Live Levels',
      //   menuItemObj: this.menuItems['Live Levels'],
      //   order: -1
      // })

      // this.$store.commit('add_menu_config_item', {
      //   name: 'Cumulative Data Table',
      //   menuItemObj: this.menuItems['Cumulative Data Table'],
      //   order: -1
      // })
    }

    try {
      const menuOrder = await this.$http.get('menuOrderConfigV2/' + this.Dbasename)
      this.menuOrder = menuOrder.data

      const resp = await this.$http.get('menuconfigV2/' + this.Dbasename + '/' + this.userId)
      this.menuConfigResp = resp.data

      if (Object.keys(this.menuConfigResp).length === 0) {
        setTimeout(async () => {
          const secondResp = await this.$http.get('menuconfigV2/' + this.Dbasename + '/' + this.userId)
          this.menuConfigResp = secondResp.data
        }, 2000)
      }

      for (const key in resp.data) {
        if (resp.data.hasOwnProperty(key)) {
          if (!resp.data[key]) {
            delete resp.data[key]
          }
        }
      }
      // resp.data = resp.data.filter(n => n)
      for (let index = 0; index < Object.keys(resp.data).length; index++) {
        const element = resp.data[index]
        if (this.menuItems[element]) {
          if (element === 'Absence' && (this.Dbasename === 'SsPeterPaul' || this.Dbasename === 'Spotlight')) {
            this.$store.commit('add_menu_config_item', {
              name: 'Report an Absence',
              menuItemObj: this.menuItems[element],
              order: index
            })
          } else if (element === 'Learning' || element === 'Spotlight') {
            try {
              const resp = await this.$http.get('configV2/' + this.Dbasename + '/atschoolPWACompletedLearningOnly')
              if (resp.data.configValue) {
                this.$store.commit('add_menu_config_item', {
                  name: 'Completed Learning',
                  menuItemObj: this.menuItems[element],
                  order: index
                })
              } else {
                this.$store.commit('add_menu_config_item', {
                  name: element,
                  menuItemObj: this.menuItems[element],
                  order: index
                })
              }
            } catch (error) {
              console.log(error)
            }
          } else {
            this.$store.commit('add_menu_config_item', {
              name: element,
              menuItemObj: this.menuItems[element],
              order: index
            })
          }
        }
      }

      if (this.menuConfig.find((element) => { return element.menuItem === 'School Website' }) !== undefined) {
        try {
          const resp = await this.$http.get('configV2/' + this.Dbasename + '/schoolwebsite')
          const website = resp.data.configValue
          if (website.includes('https://') || website.includes('http://')) {
            this.schoolWebsite = website
          } else {
            this.schoolWebsite = '//' + website
          }
        } catch (error) {
          console.log(error)
        }
      }

      if (this.menuConfig.find((element) => { return element.menuItem === 'Learning Space' }) !== undefined) {
        try {
          const resp = await this.$http.get('pupilsV2/' + this.Dbasename + '/' + this.userId + '/' + this.pupilId + '/learningSpaceLinkV2')
          const website = resp.data.url
          this.learningSpaceLink = website
        } catch (error) {
          console.log(error)
        }
      }

      if (this.menuConfig.find((element) => { return element.menuItem === 'Attendance Reports' }) !== undefined) {
        try {
          const resp = await this.$http.get('pupilsV2/' + this.Dbasename + '/' + this.pupilId + '/attendanceChartV2')

          this.attendanceLink = resp.data.url
        } catch (error) {
          console.log(error)
        }
      }

      if (this.menuConfig.find((element) => { return element.menuItem === 'Live Levels' }) !== undefined) {
        try {
          const resp = await this.$http.get('pupilsV2/' + this.Dbasename + '/' + this.pupilId + '/assessmentsGraphV2')

          this.graphLink = resp.data.url
        } catch (error) {
          console.log(error)
        }
      }

      if (this.menuConfig.find((element) => { return element.menuItem === 'Cumulative Data Table' }) !== undefined) {
        try {
          const resp = await this.$http.get('pupilsV2/' + this.Dbasename + '/' + this.pupilId + '/cumulativeDataTableV2')

          this.dataTableLink = resp.data.url
        } catch (error) {
          console.log(error)
        }
      }

      if (this.menuConfig.find((element) => { return element.menuItem === 'Learning Pathway' }) !== undefined) {
        try {
          const resp = await this.$http.get('pupilsV2/' + this.Dbasename + '/' + this.userId + '/' + this.pupilId + '/learningPathwayLinkV2')
          this.learningPathwayLink = resp.data.url
        } catch (error) {
          console.log(error)
        }
      }

      if (this.menuConfig.find((element) => { return element.menuItem === 'Student Timetable' }) !== undefined) {
        try {
          const resp = await this.$http.get('pupils/' + this.pupilId + '/spotlightCalendarLink')
          const spotlightChildCalendar = resp.data.url
          this.studentTimetablelink = spotlightChildCalendar
        } catch (error) {
          console.log(error)
        }
      }

      if (this.menuConfig.find((element) => { return element.menuItem === 'Learner Profile' }) !== undefined) {
        try {
          const resp = await this.$http.get('pupils/' + this.pupilId + '/learnerProfileLink')
          const website = resp.data.url
          this.learnerProfileLink = website
        } catch (error) {
          console.log(error)
        }
      }

      this.$store.commit('add_menu_config_item', {
        name: 'Settings',
        menuItemObj: this.menuItems['Settings'],
        order: 99
      })
    } catch (error) {
      console.log(error)
    }

    let tempPupilArr = []

    try {
      const resp = await this.$http.get('pupilsTest19/' + this.pupilId + '/' + this.userId + '/' + this.Dbasename)
      tempPupilArr.push(resp.data)

      const siblingsResp = await this.$http.get('siblingsTest19/' + this.pupilId + '/' + this.userId + '/' + this.Dbasename)
      const flattenedData = [].concat(...siblingsResp.data)

      tempPupilArr = tempPupilArr.concat(flattenedData)
      this.$store.commit('update_pupils_array', tempPupilArr)
    } catch (error) {
      console.log(error)
    }
  },
  mounted: function () {
    this.timer = setTimeout(() => {
      this.showAppAlert = true
    }, 8000)
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  }
}
</script>

<style scoped>
.container_background {
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80%;
}
.menu_layout {
  /* background-color: white; */
  border-top: 2px solid #00B0B9;
}
.overflow-hidden {
  overflow: hidden;
}
.horiz-scroll {
  overflow-y: hidden;
  overflow-x: auto;
}
.selectedBorder {
  /* border-style: solid; border-width: 3px; border-color:orange; */
  border: 8px solid #00B0B9;
}
.darkorange--text {
  color: #0C2340;
  caret-color: #0C2340;
}

@media screen and (min-width: 960px) {
  .responsive-img {
    height: 22rem !important;
  }
}

</style>
